import { render, staticRenderFns } from "./SocialSection.vue?vue&type=template&id=57ec150f&"
import script from "./SocialSection.vue?vue&type=script&lang=js&"
export * from "./SocialSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports